import { Form } from 'factorial-form'
import { makeObservable, observable, reaction } from 'mobx'
import type { $Values } from 'utility-types'

import AccessGroup from 'modules/core/store/models/AccessGroup'

type Strategy = $Values<typeof AccessGroup.Strategies> | null | undefined
type GroupableType = $Values<typeof AccessGroup.GroupableTypes> | null | undefined
interface Props {
  strategy: Strategy
  groupable_id: number | null | undefined
  groupable_type: GroupableType
}

const group = (strategy: Strategy, groupableType: GroupableType) =>
  strategy === AccessGroup.Strategies.withRegularAccess
    ? AccessGroup.Strategies.withRegularAccess
    : groupableType

class AccessGroupForm extends Form {
  members: number[] = []

  constructor({
    strategy,
    groupable_id,

    groupable_type,
  }: Props) {
    super(
      {
        group: group(strategy, groupable_type),
        strategy,
        groupable_id,
        groupable_type,
      },
      {
        group: 'string',
        strategy: 'string',
        groupable_type: 'string',
        groupable_id: 'number',
      }
    )
    makeObservable(this, {
      members: observable,
    })
    reaction(
      () => this.get('groupable_type').value,
      (value: string) => {
        this.get('groupable_id').set(null)

        if (value === AccessGroup.Strategies.withRegularAccess) {
          this.get('strategy').set(value)
        } else if (Object.values(AccessGroup.GroupableTypes).includes(value)) {
          this.get('strategy').set(AccessGroup.Strategies.groupableWithRegularAccess)
        }
      }
    )
  }

  setMembers(members: number[]) {
    this.members = members
  }

  data(): Record<string, unknown> {
    return { ...super.data(), members: this.members }
  }

  valid(): boolean {
    const strategy = this.get('strategy').value
    const groupableId = this.get('groupable_id').value
    const groupableType = this.get('groupable_type').value
    const { employees, members, withRegularAccess } = AccessGroup.Strategies

    return strategy === withRegularAccess ||
      strategy === employees ||
      (strategy === members && this.members.length > 0)
      ? true
      : Boolean(groupableId && groupableType)
  }
}

export default AccessGroupForm
